const businessPlanList = () =>
  import("@/views/businessPlan/businessPlanList.vue");
const addProfile = () => import("@/views/businessPlan/addProfile.vue");
const businessPlanDetails = () =>
  import("@/views/businessPlan/businessPlanDetails.vue");
const businessPlanEdit = () =>
  import("@/views/businessPlan/editBusinessPlan.vue");
 
export default {
  path: "/businessPlan",
  meta: { label: "Business Plan-List" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "BusinessPlanList",
      meta: {
        requiresAuth: true,
      },
      component: businessPlanList,
    },
    {
      path: "create-business-plan",
      name: "Add Business Plan",
      meta: {
        requiresAuth: true,
      },
      component: addProfile,
    },
    {
      path: "details/:id",
      name: "View Business Plan",
      meta: {
        requiresAuth: true,
      },
      component: businessPlanDetails,
    },
    {
      path: "edit/:id",
      name: "Edit Business Plan",
      meta: {
        requiresAuth: true,
      },
      component: businessPlanEdit,
    },
  ],
};
 